module.exports = __webpack_public_path__ + "static/media/search_dark.959d8944.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/search_dark.svg
// module id = 138
// module chunks = 0